// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import Vuetify from 'vuetify';
import Vuelidate from 'vuelidate';
import Toasted from 'vue-toasted';
import { createStore } from './store';
Vue.use(Toasted);
import 'vuetify/dist/vuetify.min.css'; // Ensure you are using css-loader
import '@fortawesome/fontawesome-free/css/all.css';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import VueSmoothScroll from 'vue2-smooth-scroll'


Vue.use(Vuetify);
Vue.use(Vuelidate);
Vue.use(VueSmoothScroll);

Vue.config.productionTip = false;

// navigation gaurds :B
router.beforeEach((to, from, next) => {
  if (to.meta.auth && !window.localStorage.getItem('accesstoken')) {
    next('/');
  } else {
    next();
  }
});

// WCAG 2.4.2 — every route gets a distinct, descriptive <title> so screen
// readers announce the correct page name on navigation in this SPA.
// to.matched walks parent → child, so we scan in reverse to let a child
// override (and fall back to a parent's title for nested admin routes).
const DEFAULT_TITLE = 'Grow With Stocks - SEBI Registered Research Analyst';
function resolveTitle(to) {
  if (!to || !to.matched) return DEFAULT_TITLE;
  for (let i = to.matched.length - 1; i >= 0; i--) {
    const m = to.matched[i].meta;
    if (m && m.title) return m.title;
  }
  return DEFAULT_TITLE;
}

router.afterEach((to, from) => {
  document.title = resolveTitle(to);

  // WCAG 2.4.3 — move focus to main on route change so screen reader users
  // don't stay anchored to the previous page's link.
  if (from.name === null) return; // initial load only
  setTimeout(() => {
    const main = document.getElementById('main-content');
    if (main && typeof main.focus === 'function') {
      main.focus({ preventScroll: false });
    }
  }, 0);
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store: createStore(),
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js